import { createSelector } from 'reselect';
import { getCurrentUser } from 'shared/store/app/selectors';

const selectBackLink = createSelector(getCurrentUser, (user = {}) => user.backLink);

export default selectBackLink;
